import React, { useState, useEffect, useContext } from "react";
import {
  IComponentHVideoList,
  IComponentLink,
  IMediumWithLinkId,
  IOneComponentHVideo,
} from "../../component.d";
import { IMedium, ILiveSource } from "../../store/VideoStore";
import { ThemeContext } from "../../store/ThemeProvider";
import intl from "react-intl-universal";
import { getPendantColor } from "../../utils/color";
import chroma from "chroma-js";
import ReactSVG from "react-svg";
import { getGalleryStatus, navigatorTo } from "../../utils/util";
import { inject, observer } from "mobx-react";
import Type2 from "./Type2";
import Type1 from "./Type1";

import "./AllForHVideoList.scss";
import Type2CurrentPlay from "./Type2CurrentPlay";

export interface IVideoListItem extends IMedium {
  onClick: (link: IComponentLink) => void;
  link_id: string;
  info: boolean;
  current_page_play?: boolean;
  componentData: IOneComponentHVideo;
}

const AllForHVideoList = (props: IComponentHVideoList) => {
  const { list, mode, info, rootStore, current_page_play } = props;

  const [currentIndex, setCurrentIndex] = useState(-1);

  const Comp = +mode === 1 ? Type1 : Type2;

  const onClick = (
    link: IComponentLink,
    index?: number,
    it?: IOneComponentHVideo
  ) => {
    // 只有不需要在本业播放时才需要做跳转操作
    // todo:如需测试，可以在这里取反
    if (current_page_play) {
      typeof index === "number" && setCurrentIndex(index);
    } else {
      navigatorTo(link);
    }
  };

  const { videoStore } = rootStore!;

  useEffect(() => {
    // 注意啊，要去请求了
    const ids = list
      .map((it) => {
        if (it && it.link && ["video", "live"].indexOf(it.link.type) > -1) {
          return typeof it.link.value === "object" && it.link.value?.id;
        }
        return null;
      })
      .filter(Boolean);

    if (ids?.length) {
      rootStore!.videoStore.batch(ids);
    }
  }, []);

  // console.log(list, 'list');

  const getVideoData = function (it: IOneComponentHVideo, index: number) {
    let { value } = it.link;
    if (typeof value === "object" && value?.id) {
      let video = videoStore.getVideo(value.id);
      if (video) {
        let typeProperty = Object.assign(
          {
            onClick: () => {
              onClick(it.link, index, it);
            },
            link_id: value.link_id,
            info: info,
            current_page_play: current_page_play,
            componentData: it,
          },
          video
        ) as IVideoListItem;
        return typeProperty;
      }
    }
    return null;
  };

  const currentVideo =
    currentIndex === -1 ? null : getVideoData(list[currentIndex], currentIndex);

  return (
    <div className="all-for-hvideolist">
      <div className={`hvideolist mode${mode}`}>
        {(list || []).map((it, index: number) => {
          if (it?.link && ["video", "live"].indexOf(it.link.type) > -1) {
            const typeProperty = getVideoData(it, index);
            if (typeProperty) {
              return (
                <Comp key={index + "" + typeProperty.id} {...typeProperty} />
              );
            } else {
              return (
                // @ts-ignore
                <Comp
                  key={index}
                  componentData={it}
                  info={!!info}
                  current_page_play={!!current_page_play}
                />
              );
            }
          }
          return null;
        })}
      </div>

      {+mode === 2 && currentIndex !== -1 && currentVideo && (
        <Type2CurrentPlay info={currentVideo} setIndex={setCurrentIndex} />
      )}
    </div>
  );
};

export default inject("rootStore")(observer(AllForHVideoList));
